export function bytesToSize(value) {
  if (value === 0) return '0B';
  var k = 1024;
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(value) / Math.log(k));
  return (value / Math.pow(k, i)).toPrecision(3) + sizes[i];
}
//# sourceMappingURL=utils.js.map
